import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV_CONFIG } from 'config/environment';

export const siteApi = createApi({
  reducerPath: 'siteApi',
  baseQuery: fetchBaseQuery({
    baseUrl: ENV_CONFIG().API.BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-Type', 'application/json');
      headers.set('X-API-Key', process.env.REACT_APP_API_KEY || '');

      return headers;
    },
  }),
  tagTypes: ['ShoppingCartFuzzySearch', 'ShoppingCartSearch', 'ShoppingCartSearchConfig'],
  endpoints: () => ({}),
});
